jQuery(document).ready(function($) {


	// ---------------------------------------------------------------------
	// | find a store                                                      |
	// ---------------------------------------------------------------------

	// find a store sticky sidebar (centre map) and to-top link
	(function(findSidebar) {
		var $sidebar = $('.js-card-store-container');
		var $sidebarParent = $sidebar.parent();
		var $window = $(window);
		var $offset = $sidebarParent.offset();
		var $topPadding = 30;
		var $toTop = $('.js-link-to-top');
		// sticky sidebar
		if ($sidebar.length) {
			var stickify = function() {
				if ($window.scrollTop() > $offset.top) {
					$sidebar.stop().animate({
						marginTop: $window.scrollTop() - $offset.top + $topPadding
					});
					$toTop.fadeIn('slow');
				} else {
					$sidebar.stop().animate({
						marginTop: 0
					});
					$toTop.fadeOut('slow');
				}
			};
			enquire.register('screen and (min-width: 768px)', {
				setup: function() {
					stickify();
				},
				match: function() {
					$window.on('scroll', function () {
						clearTimeout(window.scrollFinished);
						window.scrollFinished = setTimeout(function() {
							stickify();
						}, 200);
					});
					$window.on('resize', function () {
						$offset = $sidebarParent.offset();
					});
				},
				unmatch: function() {
					$toTop.removeAttr('style');
					$sidebar.stop().animate({
						marginTop: 0
					});
					$window.unbind('scroll');
				},
				deferSetup: true
			});
		}
		// scroll to top
		$toTop.on('click', function () {
			$('html, body').animate({ scrollTop: 0 }, 'slow');
			return false;
		});
	}());

	// find a store categories
	(function(findCategories) {
		// expand/collapse
		$('.js-form-category-title').on('click', function() {
			$(this).siblings('.js-form-categories').toggle();
		});
		// collapse when user clicks outside
		$(document).on('mouseup', function (e) {
			if ($('.js-form-categories').is(':visible')) {
				var $container = $('.js-form-categories');
				// if the target of the click isn't the container, its descendent, or the title...
				if (!$container.is(e.target) && $container.has(e.target).length === 0 && !$('.js-form-category-title').is(e.target) && !$('.js-form-category-title-inner').is(e.target)) {
					$container.hide();
				}
			}
		});
		// custom scrollbar
		// https://github.com/malihu/malihu-custom-scrollbar-plugin
		$('.js-form-categories').mCustomScrollbar();

		// check "all" if nothing else is selected
		var checkAll = $('.js-form-checkbox-all');
		var checkAllParent = checkAll.parents('.checkbox');
		var checkCategories = $('.js-form-category .form-checkbox')
		checkAll.iCheck('check');
		checkAllParent.addClass('untoggleable');
		checkCategories.on('ifChanged', function(e) {
			if (checkCategories.filter(':checked').length === 0) {
				checkAll.iCheck('check');
				checkAllParent.addClass('untoggleable');
			} else {
				checkAll.iCheck('uncheck');
				checkAllParent.removeClass('untoggleable');
			}
		});
	}());

	// find a store alphabet
	(function(findAlphabet) {
		// expand/collapse
		$('.js-form-alphabet-view-more').on('click', function() {
			$(this).prev('.js-form-alphabet').toggleClass('expanded');
			$(this).find('span').text(function(i, text) {
				return text === 'View More' ? 'View Less' : 'View More';
			});
		});
	}());

	// find a store and offers scroll to results on btn click and "enter"
	(function(searchSubmit) {
		var scrollToResults = function() {
			function scrollTo(element) {
				$('html, body').animate({
					scrollTop: element.offset().top - 30
				}, 700);
			}
			// find a store
			if ($('.js-store-table').length) {
				scrollTo($('.js-store-table'));
			}
			// offers
			if ($('.js-offers-list').length) {
				scrollTo($('.js-offers-list'));
			}
		};
		// scroll on btn click
		$('.js-btn-submit-filter-search').on('click', function() {
			scrollToResults();
		});
		// scroll on "enter"
		$('.js-filter-search').on('keypress', function(e) {
			if (e.which === 13) {
				e.preventDefault();
				scrollToResults();
			}
		});
	}());

	// find a store and offers isotope filtering
	// http://isotope.metafizzy.co/
	(function(isotope) {
		// all: define layout mode that doesn't position items
		Isotope.Item.prototype._create = function() {
			this.id = this.layout.itemGUID++;
			this._transn = {
				ingProperties: {},
				clean: {},
				onEnd: {}
			};
			this.sortData = {};
		};
		Isotope.Item.prototype.layoutPosition = function() {
			this.emitEvent('layout', [this]);
		};
		Isotope.prototype.arrange = function(opts) {
			this.option(opts);
			this._getIsInstant();
			this.filteredItems = this._filter(this.items);
			this._isLayoutInited = true;
		};
		Isotope.LayoutMode.create('none');

		// all: filter variables
		var qsRegex;
		var alphaFilter;
		var categoryFilters = [];
		var categoryFilter;
		var selectedCategoryNames = [];
		var selectedCategoryNamesString;

		// all: debounce text search so filtering doesn't happen every millisecond
		function debounce(fn, threshold) {
			var timeout;
			return function debounced() {
				if (timeout) {
					clearTimeout(timeout);
				}
				function delayed() {
					fn();
					timeout = null;
				}
				timeout = setTimeout(delayed, threshold || 100);
			};
		}

		// find a store: initialise isotope
		var $storeList = $('.js-store-list').isotope({
			itemSelector: '.item',
			layoutMode: 'none',
			transitionDuration: 0,
			filter: function() {
				var $this = $(this);
				// search
				var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
				// alpha
				var alphaResult = alphaFilter ? $this.is('[data-alpha~=' + alphaFilter + ']') : true;
				if(qsRegex){
					$this.removeClass('hide');
				}
				// category
				if (!categoryFilters.length) {
					return searchResult && alphaResult && 'all';
				}
				for (var i = 0; i < categoryFilters.length; i++) {
					if ($this.is('[data-category*=' + categoryFilters[i] + ']')) {
						return searchResult && alphaResult;
					}
				}
				return false;
			}
		});

		// find a store: disable category if no stores are in it
		var disableEmptyCategories = function() {
			var allCategories = $('.js-form-category');
			$('.checkbox').removeClass('hidden');
			$.each(allCategories, function() {
				var categoryKey = $(this).find('.form-checkbox').val();
				// if ($('.item[data-category*="' + categoryKey + '"]:visible').length === 0) {
				if ($('.item[data-category*="' + categoryKey + '"]').length === 0) {
					$(this).find('.checkbox').addClass('hidden');
				}
			});
		};
		disableEmptyCategories();

		// find a store: use value of search field to filter
		var $quicksearch = $('.js-filter-search').on('keyup', debounce(function() {
			qsRegex = new RegExp($quicksearch.val(), 'gi');
			$storeList.isotope();
			disableEmptyCategories();
		}, 200));

		// find a store: alphabetical filtering
		$('.js-form-alphabet').on('click', '.btn', function() {
			$('.js-form-alphabet .btn').removeClass('active');
			$(this).toggleClass('active');
			alphaFilter = $(this).text().toLowerCase();
			$storeList.isotope();
			disableEmptyCategories();
		});

		// find a store: category filtering - add filter
		$('.js-form-categories').on('ifChecked', '.form-checkbox', function(event) {
			if ($.inArray($(this).val(), categoryFilters) <= -1) {
				categoryFilters.push($(this).val());
				selectedCategoryNames.push($(this).parent().siblings('.js-checkbox-label').text());
				$storeList.isotope();
			}
			if ($(this).val() === 'all') {
				$('.js-form-categories .form-checkbox:not([value="all"])').iCheck('uncheck');
			} else {
				$('.js-form-categories .form-checkbox[value="all"]').iCheck('uncheck');
				if ($.inArray('all', categoryFilters) >= 0) {
					for (var i = 0; i < categoryFilters.length; i++) {
						if (categoryFilters[i] === 'all') {
							categoryFilters.splice(i, 1);
							$storeList.isotope();
						}
					}
				}
			}
		});

		// find a store: category filtering - remove filter
		$('.js-form-categories').on('ifUnchecked', '.form-checkbox', function(event) {
			if ($(this).val() !== 'all') {
				for (var i = 0; i < categoryFilters.length; i++) {
					if (categoryFilters[i] === $(this).val()) {
						categoryFilters.splice(i, 1);
					}
				}
			}
			for (var n = 0; n < selectedCategoryNames.length; n++) {
				if (selectedCategoryNames[n] === $(this).parent().siblings('.js-checkbox-label').text()) {
					selectedCategoryNames.splice(n, 1);
				}
			}
			$storeList.isotope();
		});

		var isCleared;

		// find a store: update page content after filtering
		$storeList.on('arrangeComplete', function(event, filteredItems) {
			// update active categories
			selectedCategoryNamesString = selectedCategoryNames.length ? selectedCategoryNames.join(', ') : 'All';
			$('.js-selected-categories').text(selectedCategoryNamesString);
			if (selectedCategoryNamesString === 'All') {
				$('.js-form-category-title-inner').text('Choose Category');
			} else {
				$('.js-form-category-title-inner').text(selectedCategoryNamesString);
			}

			// hide the message if no filters active; show a message depending on whether there are results
			if (isCleared === true) {
				$('.js-filter-message-results, .js-filter-message-no-results').fadeOut(function() {
					$(this).removeClass('active');
				});
			} else {
				if ($storeList.find('.item:visible').length === 0) {
					$('.js-filter-message-results').fadeOut(function() {
						$(this).removeClass('active');
						$('.js-filter-message-no-results').fadeIn(function() {
							$(this).addClass('active');
						});
					});
				} else {
					$('.js-filter-message-no-results').fadeOut(function() {
						$(this).removeClass('active');
						$('.js-results-count').text($('.js-store-list .item:visible').length);
						$('.js-filter-message-results').fadeIn(function() {
							$(this).addClass('active');
						});
					});
				}
			}

			// restripe the table
			// $storeList.find('.item:visible').each(function(i) {
			// 	if (i % 1 === 0) {
			// 		$(this).css('background-color', '#fbfbfb');
			// 	}
			// 	if (i % 2 === 0) {
			// 		$(this).css('background-color', '#fff');
			// 	}
			// });
		});

		// find a store: clear filters
		$('.js-filter-clear').on('click', function() {
			isCleared = true;

			function clearFilters(callback) {
				// search field
				$('.js-filter-search').val('');
				qsRegex = '';
				$storeList.isotope();
				disableEmptyCategories();

				// alpha
				$('.js-form-alphabet').find('.btn').removeClass('active');
				$('.js-btn-all').trigger('click');

				// categories
				$('.js-form-categories').find('input').iCheck('uncheck');
				$('.js-form-checkbox-all').iCheck('check');

				callback();
			};

			clearFilters(function() {
				isCleared = false;
			});
		});


		// Initialize Find a Store page
		// Gets parameter value from url
		var getUrlParameter = function (name) {
		    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		    var results = regex.exec(location.search);
		    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
		};					

		// Initialize the search with query string values. NOTE Search string is "term"
		var searchterm = getUrlParameter('term');
		if (searchterm ) {
			qsRegex = new RegExp(searchterm, 'gi');
			$storeList.isotope();
			$('.js-filter-search').val(searchterm);
		}

		disableEmptyCategories();

		var searchcategory = getUrlParameter('cat');
		if(searchcategory){
			var cateoryArray = new Array();
			cateoryArray = searchcategory.split(",")
			for (var i = cateoryArray.length - 1; i >= 0; i--) {
				var allCate = $('.js-form-category');
				$.each(allCate, function() {
					var catname = $(this).find('.js-checkbox-label').text();
					if(cateoryArray[i]===catname){
						$(this).find('.form-checkbox').iCheck('check');
					}
				});
			}
		}
		
		// ---------------------------------------------------------------------
		// | offers                                                            |
		// ---------------------------------------------------------------------

		// offers: initialise isotope
		var $offersList = $('.js-offers-list').isotope({
			itemSelector: '.item',
			layoutMode: 'none',
			transitionDuration: 0,
			filter: function() {
				var $this = $(this);
				// search
				var searchResult = qsRegex ? $this.attr('data-retailer').match(qsRegex) || $this.find('.card-title').text().match(qsRegex) : true;
				// apply filters
				return searchResult;
			}
		});

		// offers: use value of search field to filter
		var $offersearch = $('.js-filter-search').on('keyup', debounce(function() {
			qsRegex = new RegExp($offersearch.val(), 'gi');
			$offersList.isotope();
		}, 200));

		// offers: update page content after filtering
		$offersList.on('arrangeComplete', function(event, filteredItems) {
			// show a message depending on whether there are results
			if ($offersList.find('.item:visible').length === 0) {
				$('.js-filter-message-results').fadeOut(function() {
					$('.js-filter-message-no-results').fadeIn();
				});
			} else {
				$('.js-filter-message-no-results').fadeOut(function() {
					$('.js-results-count').text($('.js-offers-list .item:visible').length);
					$('.js-filter-message-results').fadeIn();
				});
			}
		});
	}());

	// Load every 4 rows store items
	(function(loadStore) {
		var tileWrap = $('.tile-view');
		if (!tileWrap.length) {
			return;
		}

		var wrap = $('.js-store-list'),
			itemStore = wrap.find('.item'),
			loadingEl = $('.loading-cont');

		if(wrap.length){
			wrap.css("visibility", "visible");
		}else{
			return;
		}

		if($(window).width() < 1024 && $(window).width() > 768){
			nStore = 8;
		}else if($(window).width() <= 768){
			nStore = 4;
		}else{
			nStore = 16;
		}

		$(window).on('resize', function() {
			if($(window).width() < 1024 && $(window).width() > 768){
				nStore = 8;
			}else if($(window).width() <= 768){
				nStore = 4;
			}else{
				nStore = 16;
			}
		})

		// Set the same height
		// 350 is the default item height
		var itemHeight = 350;
		$.each(itemStore, function(index) {
			var itemCard = $(this).find('.card');
			if(itemCard.outerHeight() > itemHeight){
				itemHeight = itemCard.outerHeight();
			}
		});
		itemStore.css('height',itemHeight+20+'px');

		// Load every 4 rows store items
		$.each(itemStore, function(index) {
			if (index >= nStore) {
				$(this).addClass('hide');
			}
		});

		// Load on Scroll
		$(window).on('scroll', function () {
			if(isScrolledIntoView(loadingEl)){
				var itemStoreHidden = wrap.find('.item.hide');
				if(itemStoreHidden.length>0){
					loadingEl.css("visibility", "visible");
				}
				setTimeout(function() {
					$.each(itemStoreHidden, function(index) {
						if (index < nStore) {
							$(this).removeClass('hide');
						}
					});

					$('.js-results-count').text(wrap.find('.item:visible').length);
				}, 1000);
			}else{
				loadingEl.css("visibility", "hidden");
			}
		});

		setTimeout(function() {
			if(!wrap.find('.item.hide').length){
				loadingEl.css("visibility", "hidden");
			}
		}, 2000);

		function isScrolledIntoView(elem){
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();

			var elemTop = $(elem).offset().top;
			var elemBottom = elemTop + $(elem).height();

			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}
	}());

	// Map Initialize
	(function(storeMap) {
		var wrap = $('.centre-map');
		if (!wrap.length) {
			return;
		}

		var el = $('#map'),
			lat = parseFloat(el.attr("data-lat")),
			lng = parseFloat(el.attr("data-lng")),
			centerPosition = { lat: lat, lng: lng };
		
		map = new google.maps.Map(document.getElementById('map'), {
			center: centerPosition,
			zoom: 14,
			streetViewControl: false,
			mapTypeControl: false,
			zoomControl: false,
			fullscreenControl: false,
			disableDefaultUI: true
		});

		var marker = new google.maps.Marker({
			position: centerPosition,
			map: map,
			zIndex: 9999999999
		});

		var url = "https://www.google.com/maps/search/"+ lat + "," + lng;
		$('.google-map').click(function(){
			window.open(url, '_blank');
		})

		$('.map-cont').click(function(){
			window.open(url, '_blank');
		})

	}());

	// Notes Initialize to remove margin bottom on breadcrumbs if there is notes container
	(function(notes) {
		var wrap = $('.ww');
		if (!wrap.length) {
			return;
		}

		$('.breadcrumbs').css('margin','0');
	}());
});
